import {getModule, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import store from '..';


@Module({ name: 'shop', store, dynamic: true })
export class ShopModule extends VuexModule {
    public shopId: number = 0;

    @Mutation
    public setShopId(shopId: number) {
        this.shopId = shopId;
    }
}

export const ModuleShop = getModule(ShopModule);
